import React, { useState, useEffect } from "react";
import DashLayout from "../../layouts/DashLayout";
import { RiUserSearchLine } from "react-icons/ri";
import { FcRefresh } from "react-icons/fc";
import { BsDownload, BsCheck } from "react-icons/bs";
import Overlay from "../../components/Overlay";
import { style } from "../../styles/Style";
import { beneficiaries } from "../../utils/DataSource";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import {
  getBeneficiaryInfo,
  getBeneficiaryParents,
  getBeneficiaryCurrentCaregivers,
  getBeneficiaryAllGroups,
  getBeneficiaryLastSaturdayStudy,
  // getBeneficiaryAllLetters,
  getBeneficiaryAllFunds,
  getBeneficiaryLastVisit,
  getBeneficiaryCurrentSchool,
  getBeneficiaryLastRecordedMarks,
  getBeneficiaryCurrentResidence,
  getBeneficiaryCurrentInsurance,
  getBeneficiaryCurrentCategory,
  getBeneficiaryAllProperties,
} from "../../store/actions/BenProfileActions";
import changeMonthToText from "../../utils/ChangeMonthToText";
function BenProfile() {
  const dispatch = useDispatch();

  const beneficiaryInfo = useSelector(
    (state) => state.benProfileState.beneficiaryInfo
  );

  const groups = useSelector((state) => state.benProfileState.allGroups);
  const parents = useSelector((state) => state.benProfileState.parents);
  // const letters = useSelector((state) => state.benProfileState.allLetters);
  const funds = useSelector((state) => state.benProfileState.allFunds);
  const lastVisit = useSelector((state) => state.benProfileState.lastVisit);
  const allProperties = useSelector(
    (state) => state.benProfileState.allProperties
  );

  const currentUbudeheCategory = useSelector(
    (state) => state.benProfileState.currentUbudeheCategory
  );

  const currentInsurance = useSelector(
    (state) => state.benProfileState.currentInsurance
  );
  const currentResidence = useSelector(
    (state) => state.benProfileState.currentResidence
  );
  const currentSchool = useSelector(
    (state) => state.benProfileState.currentSchool
  );
  const lastRecordedMarks = useSelector(
    (state) => state.benProfileState.currentScore
  );
  const lastSatStudy = useSelector(
    (state) => state.benProfileState.lastSatStudy
  );
  const currentCaregivers = useSelector(
    (state) => state.benProfileState.currentCaregivers
  );
  const loaders = useSelector((state) => state.loadersState);

  // overlays
  const [searchBenOverlay, openSearchBeneOverlay] = useState(0);
  function searchOverlayController() {
    openSearchBeneOverlay(!searchBenOverlay);
  }

  const { benId } = useParams();
  const selectedBeneficiaryId = benId;

  useEffect(() => {
    dispatch(getBeneficiaryInfo(selectedBeneficiaryId));
    dispatch(getBeneficiaryParents(selectedBeneficiaryId));
    dispatch(getBeneficiaryCurrentCaregivers(selectedBeneficiaryId));
    dispatch(getBeneficiaryAllGroups(selectedBeneficiaryId));
    dispatch(getBeneficiaryLastSaturdayStudy(selectedBeneficiaryId));
    dispatch(getBeneficiaryAllFunds(selectedBeneficiaryId));
    dispatch(getBeneficiaryLastVisit(selectedBeneficiaryId));
    dispatch(getBeneficiaryCurrentSchool(selectedBeneficiaryId));
    dispatch(getBeneficiaryLastRecordedMarks(selectedBeneficiaryId));
    dispatch(getBeneficiaryCurrentResidence(selectedBeneficiaryId));
    dispatch(getBeneficiaryCurrentInsurance(selectedBeneficiaryId));
    dispatch(getBeneficiaryCurrentCategory(selectedBeneficiaryId));
    dispatch(getBeneficiaryAllProperties(selectedBeneficiaryId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBeneficiaryId, dispatch]);

  const noLoader =
    !loaders.benProfile.fetchingBenInfo &
    !loaders.benProfile.fetchingBenParent &
    !loaders.benProfile.fetchingBenCurrentCaregiver &
    !loaders.benProfile.fetchingBenCurrentInsurance &
    !loaders.benProfile.fetchingBenCurrentCategory &
    !loaders.benProfile.fetchingBenCurrentResidence &
    !loaders.benProfile.fetchingBenCurrentSchool &
    !loaders.benProfile.fetchingBenLastRecordedMarks &
    !loaders.benProfile.fetchingBenLastAttendedSatStudy &
    !loaders.benProfile.fetchingBenLastAttendedMeeting &
    !loaders.benProfile.fetchingBenLastAttendedVisit &
    !loaders.benProfile.fetchingBenLastJoinedAssocciation &
    !loaders.benProfile.fetchingBenLastFund &
    !loaders.benProfile.fetchingBenGroups &
    !loaders.benProfile.fetchingBenProperties &
    !loaders.benProfile.fetchingBenTotalMeetings &
    !loaders.benProfile.fetchingBenTotalSatStudies &
    !loaders.benProfile.fetchingBenTotalVisits &
    !loaders.benProfile.fetchingBenTotalAssocciations &
    !loaders.benProfile.fetchingBenTotalFunds;
  return (
    <DashLayout>
      <div className="bg-white rounded mx-10 mb-5 flex flex-col">
        <div className="flex p-10 pl-10 pb-4">
          <div className="flex flex-col lg:flex-row w-full  pt-5  pb-0">
            <h2 className="font-semibold">Beneficiary Profile</h2>
            <div className="md:m-auto md:mr-0">
              <button
                className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                onClick={() => {
                  searchOverlayController();
                }}
              >
                <RiUserSearchLine />
              </button>
              <button className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100">
                <FcRefresh />
              </button>
              <button className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100">
                <BsDownload />
              </button>
            </div>
          </div>{" "}
        </div>

        {/* <div className="border-b border-gray-300 ml-10 mr-10" /> */}
        {noLoader ? (
          noLoader && !beneficiaryInfo.id ? (
            <div
              className={
                "bg-gray-100 fit-content  text-xs rounded text-center py-2 mb-3 px-4 text-gray-500 font-semibold m-auto"
              }
            >
              <p>{"Beneficiary profile is not found"}</p>
            </div>
          ) : (
            <div>
              <div className="p-5 pl-10 flex flex-col lg:flex-row  w-full">
                {/* full identity */}
                <div className="border border-gray-200 rounded p-4  w-full mr-4 h-auto">
                  <h2 className="font-semibold">Basic info</h2>
                  <div className="flex">
                    <img
                      src="https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
                      className="w-10 rounded-full pl-0 border border-gray-100 my-auto mr-3"
                      alt="user"
                    />
                    <div className="p-3">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Beneficiary Id
                        </span>{" "}
                        <p>
                          {" "}
                          {beneficiaryInfo.beneficiaryCode ? (
                            beneficiaryInfo.beneficiaryCode
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </p>
                      </div>
                      <div className="flex flex-wrap">
                        <p className="text-gray-600 my-auto ml-0 w-24 mr-3 font-medium">
                          Name
                        </p>{" "}
                        <p className="fit-content flex">
                          <p className="pr-2">
                            {beneficiaryInfo.firstName ? (
                              beneficiaryInfo.firstName
                            ) : (
                              <p className="w-10 bg-gray-100 rounded h-2"></p>
                            )}
                          </p>{" "}
                          <span>
                            {beneficiaryInfo.lastName ? (
                              beneficiaryInfo.lastName
                            ) : (
                              <p className="w-10 bg-gray-100 rounded h-2"></p>
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          BirthDate
                        </span>{" "}
                        <span>
                          {" "}
                          {beneficiaryInfo.birthDate ? (
                            changeMonthToText(beneficiaryInfo.birthDate)
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Gender
                        </span>{" "}
                        <span>
                          {" "}
                          {beneficiaryInfo.gender ? (
                            capitalizeFirstLetter(beneficiaryInfo.gender)
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Status
                        </span>{" "}
                        <span className="py-1 rounded  font-normal fit-content">
                          {" "}
                          {beneficiaryInfo.status ? (
                            capitalizeFirstLetter(beneficiaryInfo.status)
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* caregivers */}
                <div className="border border-gray-200 rounded p-4 mt-8 lg:mt-0 w-full   h-auto">
                  <h2 className="font-semibold">Caregivers and parents</h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Father
                        </span>{" "}
                        <span>
                          {" "}
                          {parents.father ? (
                            parents.father
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Mother
                        </span>{" "}
                        <span>
                          {" "}
                          {parents.mother ? (
                            parents.mother
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Caregivers
                        </span>{" "}
                        <span>
                          {" "}
                          {currentCaregivers.caregiverName &&
                          currentCaregivers.relationName ? (
                            currentCaregivers.caregiverName +
                            "(" +
                            currentCaregivers.relationName +
                            ")"
                          ) : currentCaregivers.caregiverName ? (
                            currentCaregivers.caregiverName
                          ) : currentCaregivers.relationName ? (
                            currentCaregivers.relationName
                          ) : (
                            <p className="w-20 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Parents status
                        </span>{" "}
                        <span className="py-1  rounded  font-normal fit-content">
                          {" "}
                          {parents.status ? (
                            parents.status
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-5 pl-10 flex flex-col lg:flex-row  w-full">
                {/* sat programs */}
                <div className="border border-gray-200 rounded p-4 w-full mr-4   h-auto">
                  <h2 className="font-semibold">Project program</h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-8 w-28 font-medium">
                          Groups
                        </span>{" "}
                        <p className="flex">
                          {" "}
                          {groups.length < 1 ? (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          ) : (
                            groups.map((group, i) => {
                              return (
                                <span
                                  className="border bg-gray-50 border-indigo-100 px-2 mr-1 rounded  text-indigo-500 font-normal"
                                  key={i}
                                >
                                  {group.name}
                                </span>
                              );
                            })
                          )}
                        </p>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Last saturday study
                        </span>{" "}
                        <span className="m-auto py-1  font-normal fit-content">
                          {" "}
                          {lastSatStudy.attendStudy &&
                          lastSatStudy.attendStudy.name ? (
                            lastSatStudy.attendStudy.name
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>

                      <div className="flex font-medium">
                        <span className="text-gray-600 m-auto ml-0 mr-8 w-28">
                          Funds and gifts
                        </span>{" "}
                        <span>
                          {" "}
                          {funds.length > 0 ? (
                            funds.length
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex font-medium">
                        <span className="text-gray-600 m-auto ml-0 mr-0 w-30">
                          Last visit
                        </span>{" "}
                        <span className="mx-2 py-1 font-normal fit-content">
                          {" "}
                          {lastVisit.visit && lastVisit.visit.name ? (
                            lastVisit.name
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* academics */}
                <div className="border border-gray-200 rounded p-4 mt-8 lg:mt-0  w-full  h-auto ">
                  <h2 className="font-semibold">Academics </h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          School
                        </span>{" "}
                        <span>
                          {" "}
                          {currentSchool.school &&
                          currentSchool.school.schoolName ? (
                            currentSchool.school.schoolName
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Class
                        </span>{" "}
                        <span>
                          {" "}
                          {lastRecordedMarks.beneficiaryClass ? (
                            lastRecordedMarks.beneficiaryClass
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Section
                        </span>{" "}
                        <span>
                          {" "}
                          {lastRecordedMarks.section ? (
                            lastRecordedMarks.section
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Current score
                        </span>{" "}
                        <span className="py-1 font-normal fit-content">
                          {" "}
                          {lastRecordedMarks.marks ? (
                            lastRecordedMarks.marks
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-5 pl-10 flex flex-col lg:flex-row  w-full">
                {/* residence */}
                <div className="border border-gray-200 rounded p-4 mr-4 w-full  h-auto">
                  <h2 className="font-semibold">Residence </h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 ">
                          Country
                        </span>{" "}
                        <span> {"Rwanda"}</span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Province
                        </span>{" "}
                        <span>
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.province ? (
                            currentResidence.location.province
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          District
                        </span>{" "}
                        <span>
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.district ? (
                            currentResidence.location.district
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Sector
                        </span>{" "}
                        <span>
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.sector ? (
                            currentResidence.location.sector
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Cell
                        </span>{" "}
                        <span>
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.cell ? (
                            currentResidence.location.cell
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Village
                        </span>{" "}
                        <span>
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.village ? (
                            currentResidence.location.village
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-24 font-medium">
                          Center
                        </span>{" "}
                        <span className="py-1 font-normal fit-content">
                          {" "}
                          {currentResidence.location &&
                          currentResidence.location.commonName ? (
                            currentResidence.location.commonName
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* healthy */}
                <div className="border border-gray-200 rounded p-4 mt-8 lg:mt-0 w-full h-auto">
                  <h2 className="font-semibold">Healthy </h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Insurance
                        </span>{" "}
                        <span>
                          {" "}
                          {currentInsurance.insuranceCategories &&
                          currentInsurance.insuranceCategories.name ? (
                            currentInsurance.insuranceCategories.name
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Ubudehe category
                        </span>{" "}
                        <span>
                          {" "}
                          {currentUbudeheCategory.category &&
                          currentUbudeheCategory.category.name ? (
                            currentUbudeheCategory.category.name
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          House hold head Name
                        </span>{" "}
                        <span>
                          {currentUbudeheCategory.category &&
                          currentUbudeheCategory.category.beneficiaryHHD &&
                          currentUbudeheCategory.category.beneficiaryHHD
                            .fullName ? (
                            currentUbudeheCategory.category.beneficiaryHHD
                              .fullName
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          House hold head Id
                        </span>{" "}
                        <span>
                          {currentUbudeheCategory.category &&
                          currentUbudeheCategory.category.beneficiaryHHD &&
                          currentUbudeheCategory.category.beneficiaryHHD
                            .idnumber ? (
                            currentUbudeheCategory.category.beneficiaryHHD
                              .idnumber
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="text-gray-600 m-auto ml-0 mr-3 w-32 font-medium">
                          Family members
                        </span>{" "}
                        <span>
                          {currentUbudeheCategory.category &&
                          currentUbudeheCategory.category.beneficiaryHHD &&
                          currentUbudeheCategory.category.beneficiaryHHD
                            .numberOfFamilyMembers ? (
                            currentUbudeheCategory.category.beneficiaryHHD
                              .numberOfFamilyMembers
                          ) : (
                            <p className="w-10 bg-gray-100 rounded h-2"></p>
                          )}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-5 pl-10 flex flex-row w-full">
                {/* economic status */}
                <div className="border border-gray-200 rounded p-4 w-full   h-auto">
                  <h2 className="font-semibold">Economy</h2>
                  <div className="flex">
                    <div className="p-3 pl-0">
                      {allProperties.length < 1 ? (
                        <p className="w-40 bg-gray-100 rounded h-2"></p>
                      ) : (
                        allProperties.map((property, i) => {
                          return (
                            <div className="flex" key={i}>
                              <span className="text-gray-600 m-auto ml-0 mr-3 fit-content">
                                {property.amount} {property.name}
                              </span>{" "}
                              <BsCheck className="my-auto text-indigo-500" />
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="spinner m-auto mb-5 indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        )}
      </div>

      {/* filter Academics score overlay */}
      <div className={searchBenOverlay ? "flex w-screen" : "hidden"}>
        <Overlay>
          <div className="p-10 bg-white m-auto  rounded">
            <div className="flex">
              <h2 className="font-semibold w-60">{"Search beneficiary"}</h2>
              <div className="m-auto mr-0">
                <button
                  className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                  onClick={() => {
                    searchOverlayController();
                  }}
                >
                  <IoCloseOutline className="text-white" />{" "}
                </button>
              </div>
            </div>{" "}
            <div className="flex flex-col pt-3">
              {/*  field */}
              <div className="py-2  w-full">
                <label>Beneficiary Id </label>
                <Select options={beneficiaries} />
              </div>

              {/* save btn */}
              <button type="submit" className={style.loginBtn} disabled>
                <p className="m-auto">{"Search"}</p>
              </button>
            </div>
          </div>
        </Overlay>
      </div>
    </DashLayout>
  );
}

export default BenProfile;
